import React, { useState, useEffect } from 'react'
import { Formik, Field, Form } from 'formik'
import { Input, FormGroup, Label, Button, Card, CardBody, CardTitle, Row, Col, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import PropTypes from 'prop-types';
import Dropzone from "react-dropzone"
import { Link } from "react-router-dom"
import { useQuery } from 'react-query';
import { addNewExpense, getExpenseCategories, updateExpense } from 'helpers/fakebackend_helper';
import { QueryClient, useMutation } from 'react-query';


ExpenseForm.propTypes = {
  closeModal: PropTypes.func,
  isEditing: PropTypes.bool,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    amount: PropTypes.number,
    category: PropTypes.string,
    receipts: PropTypes.arrayOf(PropTypes.object),  // Array of receipt objects
  }),
};
export default function ExpenseForm({ closeModal, isEditing = false, initialValues = {} }) {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  // const [category, setCategory] = useState(initialValues.category || '')
  const [selectedFiles, setselectedFiles] = useState([])
  const [rawFiles, setRawFiles] = useState([])

  const { data: expenseCategory, isLoading } = useQuery('expense_category', getExpenseCategories, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const queryClient = new QueryClient()

  const { mutate: addExpense, isLoading: isAddLoading } = useMutation(addNewExpense);
  const { mutate: editExpense, isLoading: isEditLoading } = useMutation(updateExpense);



  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)

  const handleSubmit = (values, { resetForm }) => {
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('description', values.description);
    formData.append('amount', values.amount);
    rawFiles.forEach((file, index) => {
      formData.append(`receipt[${index}]`, file);
    });
    for (let pair of formData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }
    if (isEditing) {
      console.log('Editing expense:', formData);

      formData.append('expense_category_id', values.category.id);
      formData.append('status', values.status);
      formData.append('id', values.id);

      editExpense(formData, {
        onSuccess: () => {
          queryClient.invalidateQueries('expense_list');
          resetForm(); // Call resetForm here
          setRawFiles([])
          closeModal()
        }
      });
    } else {

      console.log('Adding expense:', formData);
      formData.append('expense_category_id', values.category);


      addExpense(formData, {
        onSuccess: () => {
          queryClient.invalidateQueries('expense_list');
          resetForm(); // Call resetForm here
          setRawFiles([])
          closeModal()
        }
      });




    }
  }

  function handleAcceptedFiles(files) {
    setRawFiles(files)
    console.log(files)
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
    setselectedFiles(files)
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  return (
    <Formik
      initialValues={{
        name: initialValues.name || '',
        description: initialValues.description || '',
        amount: initialValues.amount || '',
        category: initialValues.category || initialValues.expense_category_id || '',
        id: initialValues.id || '',
        status: initialValues.status || '',
      }}
      onSubmit={handleSubmit}
    >
      {({ handleChange, values }) => (
        <Card className="mx-auto"  >
          <CardBody>
            <CardTitle className="text-center" tag="h2">
              {isEditing ? 'Edit Expense' : 'Add Expense'}
            </CardTitle>
            <Form>
              <div className="mx-auto">
                <FormGroup >
                  <Label for="name">Expense Name</Label>
                  <Field
                    name="name"
                    as={Input}
                    id="name"
                    placeholder="Enter expense name"
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="description">Description</Label>
                  <Field
                    name="description"
                    as={Input}
                    type="textarea"
                    id="description"
                    placeholder="Enter expense description"
                  />
                </FormGroup>
                {!isEditing && (
                  <FormGroup>
                    <Label for="amount">Amount</Label>
                    <Field
                      name="amount"
                      as={Input}
                      type="number"
                      id="amount"
                      placeholder="Enter amount"
                      value={values.amount}
                      onChange={handleChange}
                    />
                  </FormGroup>
                )}
                {isEditing && (
                  <FormGroup>
                    <Label for="expense_status">Status</Label>
                    <div style={{ display: 'block' }}> {/* Ensure block display */}
                      <Field as="select" name="status" id="expense_status" style={
                        {
                          width: '100%',
                          height: '50px', borderColor: '#ccc', borderRadius: '5px', borderWidth: '1px', borderStyle: 'solid', padding: '10px', marginBottom: '10px'

                        }}>
                        <option value="" disabled>Select status</option>
                        <option value="pending">Pending</option>
                        <option value="inreview">In Review</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                        <option value="paid">Paid</option>
                        <option value="unpaid">Unpaid</option>
                      </Field>
                    </div>
                  </FormGroup>

                )}
                <FormGroup>
                  <Label for="category">Expense Category</Label>
                  <div style={{ display: 'block' }}> {/* Ensure block display */}
                    <Field as="select" name="category" id="category" style={
                      {
                        width: '100%',
                        height: '50px', borderColor: '#ccc', borderRadius: '5px', borderWidth: '1px', borderStyle: 'solid', padding: '10px', marginBottom: '10px'
                      }}>
                      <option value="" disabled>Select category</option>
                      {expenseCategory?.expense_categories.map(category => (
                        <option key={category.id} value={category.id}>{category.name}</option>
                      ))}
                    </Field>

                  </div>
                </FormGroup>

                <FormGroup>
                  <Label for="receipts">Receipts</Label>
                  <Dropzone
                    onDrop={acceptedFiles => {
                      handleAcceptedFiles(acceptedFiles)
                    }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="dropzone" style={{ height: '50px' }}>
                        <div
                          className="dz-message needsclick mt-2"
                          {...getRootProps()}
                        >
                          <input {...getInputProps()} />
                          <div className="mb-3">
                            <i className="display-4 text-muted bx bxs-cloud-upload" />
                          </div>
                          <h4>Drop files here or click to upload receipts</h4>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                  <div className="dropzone-previews mt-3" id="file-previews">
                    {selectedFiles.map((f, i) => {
                      return (
                        <Card
                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                          key={i + "-file"}
                        >
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="80"
                                  className="avatar-sm rounded bg-light"
                                  alt={f.name}
                                  src={f.preview}
                                />
                              </Col>
                              <Col>
                                <Link
                                  to="#"
                                  className="text-muted font-weight-bold"
                                >
                                  {f.name}
                                </Link>
                                <p className="mb-0">
                                  <strong>{f.formattedSize}</strong>
                                </p>
                              </Col>
                            </Row>
                          </div>
                        </Card>
                      )
                    })}
                  </div>
                </FormGroup>


              </div>
              <div className="mt-5 d-flex justify-content-end">
                <Button color="secondary" type="button" onClick={closeModal}  style={{ backgroundColor: "#2F8C47",marginRight: '12px' }}>
                  Close
                </Button>
                <Button color="primary" style={{ backgroundColor: "#2F8C47" }} type="submit" disabled={isEditing ? isEditLoading : isAddLoading}>
                  {(isEditing ? isEditLoading : isAddLoading) ? 'Loading...' : (isEditing ? 'Update Expense' : 'Submit Expense')}
                </Button>
              </div>

            </Form>
          </CardBody>
          {/* {JSON.stringify(initialValues)} */}
        </Card>
      )}
    </Formik>
  )
}


